import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faHandshake, faCamera } from '@fortawesome/free-solid-svg-icons';
import { StepProps } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const Title = styled.h2`
  ${tw`text-2xl font-bold text-text-primary mb-2`}
`;

const Subtitle = styled.p`
  ${tw`text-text-secondary mb-8`}
`;

const InfoCardsContainer = styled.div`
  ${tw`flex flex-col gap-4 mb-8`}
`;

const InfoCard = styled.div`
  ${tw`flex items-start gap-4 p-4 bg-bg-secondary rounded-lg`}
`;

const IconWrapper = styled.div`
  ${tw`flex-shrink-0 w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center`}
`;

const Icon = styled(FontAwesomeIcon)`
  ${tw`text-black`}
`;

const CardContent = styled.div`
  ${tw`flex-1`}
`;

const CardTitle = styled.h3`
  ${tw`font-semibold text-text-primary mb-1`}
`;

const CardDescription = styled.p`
  ${tw`text-sm text-text-secondary`}
`;

const GetStartedButton = styled.button`
  ${tw`w-full py-4 bg-black text-white font-semibold rounded-card mt-auto`}
  &:hover {
    ${tw`bg-pink-700`}
  }
`;

const InstructionsStep: React.FC<StepProps> = ({ onNext }) => {
  return (
    <Container>
      <Title>Report damage</Title>
      <Subtitle>This report will be shared with your guest or host.</Subtitle>

      <InfoCardsContainer>
        <InfoCard>
          <IconWrapper>
            <Icon icon={faClock} />
          </IconWrapper>
          <CardContent>
            <CardTitle>Time frame</CardTitle>
            <CardDescription>
              You have 24 hours from the end of the trip to report damage.
            </CardDescription>
          </CardContent>
        </InfoCard>

        <InfoCard>
          <IconWrapper>
            <Icon icon={faHandshake} />
          </IconWrapper>
          <CardContent>
            <CardTitle>Resolve directly</CardTitle>
            <CardDescription>
              Try to resolve the issue directly with the other party before submitting a claim.
            </CardDescription>
          </CardContent>
        </InfoCard>

        <InfoCard>
          <IconWrapper>
            <Icon icon={faCamera} />
          </IconWrapper>
          <CardContent>
            <CardTitle>Provide photos</CardTitle>
            <CardDescription>
              Upload before and after photos to document the damage.
            </CardDescription>
          </CardContent>
        </InfoCard>
      </InfoCardsContainer>

      <GetStartedButton onClick={onNext}>Get started</GetStartedButton>
    </Container>
  );
};

export default InstructionsStep;
